import { Button, Center, LoadingOverlay, Paper, PasswordInput, Stack, Title } from '@mantine/core';
import { useForm } from '@mantine/form';
import React from 'react'
import { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useInfoModal from '../hooks/useInfoModal';
import { RegistrationFormValidations } from '../components/forms/validations/FormValidations';
import { useEffect } from 'react';
import { AppDataService } from '../services/AppDataService';
import { MODAL_TYPE_ENUM } from '../enums/CommonEnums';
import GeneralErrorScreen from '../components/GeneralErrorScreen';

const ResetPassword = () => {
  const [params, setParams] = useSearchParams();
  const [tokenValid, setTokenValid] = useState(true);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);
  const openModal = useInfoModal();
  const navigate = useNavigate();

  // make a call to the server to check token validity and then set tokenValid prop

  useEffect(() => {
    // call api to validate token
    const checkToken = async () => {
      setLoading(true);

      const response = await AppDataService.ValidateResetPasswordToken({ token: params.get('token')});

      if(response.hasError()) {
        setLoading(false);
        setTokenValid(false);
      }
      else {
        const responseData = response.getResponse();

        setUserId(responseData.data.data.id);
        setLoading(false);
        setTokenValid(true);
      }
    }

    checkToken().catch(e => {
      setLoading(false);
      setTokenValid(false);
      openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, e.message);
    });
  }, []);

  const form = useForm({
    initialValues: {
      password: '',
      confirmPassword: '',
    },

    validate: {
      password: RegistrationFormValidations.contactPassword,
      confirmPassword: RegistrationFormValidations.confirmContactPassword
    },
  });
  

  const handlePasswordChange = async () => {
    try {
      setLoading(true);
      const response = await AppDataService.ResetPassword({ userId, newPassword: form.values.password, confirmNewPassword: form.values.confirmPassword });
      const responseData = response.getResponse();

      if(response.hasError()) openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, 'An unknown error occurred. Please try again later.');
      else {
        openModal(MODAL_TYPE_ENUM.GENERAL_SUCCESS, 'Your password has been reset successfully. You may now login with the new password.');
      } 

      setLoading(false);
    }
    catch(e) {
      openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, e.message)
      setLoading(false);
    }
  }

  return (
    <Center>
      <LoadingOverlay visible={loading} overlayBlur={2} />
      <Paper shadow='sm' withBorder p={50} miw={600} maw={800}>
      {
        (tokenValid && userId) ? (
          <Stack>
            <PasswordInput 
              size='md'
              withAsterisk
              label="Password"
              name="password"
              placeholder="New Password"
              {...form.getInputProps('password')}
            />
            <PasswordInput 
              size='md'
              withAsterisk
              label="Confirm Password"
              name="confirmPassword"
              placeholder="Confirm Password"
              {...form.getInputProps('confirmPassword')}
            />
            <Button onClick={form.onSubmit(handlePasswordChange)}>Submit</Button>
          </Stack>
        ) : (
          <>
            <GeneralErrorScreen 
              message='The link is invalid or expired. You will need to submit a new password request to generate a new link.'
            />
          </>
        )
      }
      </Paper>
    </Center>
  )
}

export default ResetPassword